import React, { Component, useRef } from 'react'
import ReactPlayer from 'react-player'
// import RPlayer from './ReactPlayer'
import ReactSlider from 'react-slider'
import shortenString from '../helpers/shortenString'
import Duration from '../Player/Duration'
import hitApi from '../../app/services/playbackPositionApi'
import { BackwardIcon, ForwardIcon, PauseIcon, PlayIcon, XMarkIcon } from '@heroicons/react/16/solid'
import MoreInfoNew from './MoreInfoNew'
import EpisodesNew from './EpisodesNew'
import SharePodcast from './SharePodcast'
import SubscribePodcast from './SubscribePodcast'
import darkLogo from '../../../src/hh_logo_dark.svg'
import lightLogo from '../../../src/hh_logo_light.svg'
import lightBg from '../../../src/bg_light.svg'
import darkBg from '../../../src/bg_dark.svg'
import VolumeBar from './VolumeBar'


const fonts = [{
    'font-family': 'Plus Jakarta Sans',
    'id': 'default'
}, {
    'font-family': 'Roboto',
    'id': 'roboto'
}, {
    'font-family': 'Open Sans',
    'id': 'open-sans'
}, {
    'font-family': 'Montserrat',
    'id': 'montserrat'
}, {
    'font-family': 'Lato',
    'id': 'lato'
}, {
    'font-family': 'Poppins',
    'id': 'poppins'
}, {
    'font-family': 'Inter',
    'id': 'inter'
}, {
    'font-family': 'Raleway',
    'id': 'raleway'
}, {
    'font-family': 'Playfair Display',
    'id': 'playfair-display'
}, {
    'font-family': 'Merriweather',
    'id': 'merriweather'
}, {
    'font-family': 'Afacad Flux',
    'id': 'afacad-flux'
}
]


class TWHHPlayer extends Component {


    constructor(props) {
        super(props)
        this.timer = null
        this.hitTime = new Date().getTime()
        this.progressBarRef = React.createRef();
        this.progressBarRef1 = React.createRef();
        this.state = {
            url: null,
            playing: false,
            volume: 1.0,
            muted: false,
            played: 0,
            loaded: 0,
            duration: 0,
            incrementValue: 2,
            playbackRate: 1.0,
            loop: false,
            podcast: this.props.podcast,
            originalOrderedEpisodes: this.props.episodes,
            tempEpisodes: [...this.props.episodes].reverse(),
            episodes: this.props.episodes,
            episodeCount: this.props.episodes.length,
            activeEpisode: this.props.episodes[0],
            showShare: false,
            showMenu: false,
            showSubscribe: false,
            showMoreOptions: false,
            platforms: this.props.platforms,
            rss: this.props.rss,
            toShowOnlyParticularEpisode: false,
            isLogo: this.props.isLogo,
            showVolume: false
        }
        this.escFunction = this.escFunction.bind(this);
    }


    escFunction(event) {
        if (event.key === "Escape") {
            this.setState({
                showMenu: false,
                showShare: false,
                showSubscribe: false,
                showMoreOptions: false
            })
        }
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.escFunction, false);
    }

    handleHitApi = (isPlaying = false, forwarded = false, newPlayed = undefined) => {
        var timeDiff = (new Date().getTime()) - this.hitTime
        // minimum delay to hit api is 1 sec.
        if (timeDiff < 1000) {
            return
        }
        if (this.timer != null) {
            clearTimeout(this.timer);
        }
        const { played, duration, activeEpisode, incrementValue } = this.state;
        const playedPercentage = newPlayed ? newPlayed : forwarded ? (10 / duration) + played : played
        // if isPlaying false then just hit api and if isplaying true with player true then start timer
        if (this.state.playing && isPlaying || !isPlaying) {
            this.hitTime = new Date().getTime();
            hitApi(playedPercentage, duration, activeEpisode, this.state.rss.includes(".com/"), this.state.podcast)
                .then((data) => { }).catch((error) => { });
            if (isPlaying && incrementValue > 2 && played != 0) {
                this.timer = setTimeout(() => this.handleHitApi(true), incrementValue * 1000)
            }
        }

    };

    componentDidMount() {
        document.addEventListener("keydown", this.escFunction, false);

        // for most recent episode
        if (this.props.onlyEpisode && !this.props.chosenEpisodeId) {
            this.setState({
                toShowOnlyParticularEpisode: true
            }, () => {
                // if it's single episode then show the most recent or selected ones
                let episode = this.props.isSerial ? this.props.episodes[this.props.episodes.length - 1] : this.props.episodes[0]
                this.load(episode.enclosure.url, episode)
            })
        }
        // Check if episode id is valid and exists
        if (this.props.chosenEpisodeId) {
            let filteredList = this.state.episodes.filter((it) => it.link.includes(this.props.chosenEpisodeId))
            if (filteredList.length > 0) {
                this.setState({ activeEpisode: filteredList[0], toShowOnlyParticularEpisode: true })
            } else {
                this.setState({ activeEpisode: this.state.originalOrderedEpisodes[0], toShowOnlyParticularEpisode: true })
            }
        } // the below if satisfying old version condition
        else if (this.props.chosenEpisode && this.props.chosenEpisode > 0 && this.props.chosenEpisode <= this.state.episodeCount) {
            this.setState({ activeEpisode: this.state.tempEpisodes[this.props.chosenEpisode - 1] })
        }
    }

    playEpisode = (episode) => {
        console.log("playEpisode", episode)
        this.setState({ activeEpisode: episode })
        this.load(episode.enclosure.url, episode)
        this.handlePlay()
    }

    toggleVolume = () => {
        this.setState({
            showVolume: !this.state.showVolume,
        })
    }

    playNextEpisode = () => {
        let currEpIndex = this.state.episodes.findIndex(episode => episode.guid === this.state.activeEpisode.guid);
        if (currEpIndex < (this.state.episodeCount - 1)) {
            this.load(this.state.episodes[currEpIndex + 1].enclosure.url, this.state.episodes[currEpIndex + 1])
            this.handlePlay()
        }
    }

    playPreviousEpisode = () => {
        let currEpIndex = this.state.episodes.findIndex(episode => episode.guid === this.state.activeEpisode.guid);
        if (currEpIndex > 0) {
            this.load(this.state.episodes[currEpIndex - 1].enclosure.url, this.state.episodes[currEpIndex - 1])
            this.handlePlay()
        }
    }

    load = (url, episode, skipAutoplay = false) => {
        const originalUrl = url;
		// Split at the first '?' and take the first piece (the base URL).
		const baseUrl = originalUrl.split('?')[0];
		// Build your new URL with a single query parameter.
		const finalUrl = baseUrl + '?s=hh-embed-player-v1';
		// Pass finalUrl to .load
		this.setState({
			url: skipAutoplay ? null : finalUrl,
			played: 0,
			loaded: 0,
			pip: false,
			activeEpisode: episode
		})
    }

    handlePlayPause = () => {
        this.setState({ playing: !this.state.playing })
    }

    handleStop = () => {
        this.setState({ url: null, playing: false })
    }

    handleToggleLoop = () => {
        this.setState({ loop: !this.state.loop })
    }

    handleVolumeChange = e => {
        this.setState({ volume: parseFloat(e.target.value) })
    }

    handleToggleMuted = () => {
        this.setState({ muted: !this.state.muted })
    }

    handleSetPlaybackRate = e => {
        if (this.state.playbackRate == 2)
            this.setState({ playbackRate: parseFloat(1) })
        else
            this.setState({ playbackRate: parseFloat(this.state.playbackRate + 0.25) })
    }

    handlePlay = () => {
        // If URL is not set, load it first
        if (!this.state.url) {
            this.load(this.state.activeEpisode.enclosure.url, this.state.activeEpisode)
        }
        this.setState({ playing: true })
        if (this.state.incrementValue > 2) {
            this.timer = setTimeout(() => this.handleHitApi(true), this.state.incrementValue * 1000)
        }
    }

    handlePause = () => {
        this.setState({ playing: false })
        this.handleHitApi();
    }

    handleSeekMouseDown = e => {
        this.setState({ seeking: true })
    }

    handleSeekChange = e => {
        var newPlayed = parseFloat(e)
        this.setState({ played: newPlayed })
        // here delay in increment secs
        if (this.state.incrementValue > 2 && this.state.playing) {
            this.handleHitApi(true, true, newPlayed)
        } else {
            this.handleHitApi(false, false, newPlayed)
        }
    }

    handleSeekMouseUp = e => {
        this.setState({ seeking: false })
        this.player.seekTo(parseFloat(e))
    }

    rewind = () => {
        this.player.seekTo(parseFloat(this.state.playedSeconds - 10))
    }

    fastForward = () => {
        this.player.seekTo(parseFloat(this.state.playedSeconds + 10))
        // here delay in increment secs
        if (this.state.incrementValue > 2 && this.state.playing) {
            this.handleHitApi(true, true)
        } else {
            this.handleHitApi(false, true)
        }
    }

    handleProgress = state => {
        // We only want to update time slider if we are not currently seeking
        if (!this.state.seeking) {
            this.setState(state)
        }
    }

    handleEnded = () => {
        this.setState({ playing: this.state.loop, played: 1 })
        this.handleHitApi();
    }

    handleDuration = (duration) => {
        var incrementValue = 3
        if (duration <= 60) {
            incrementValue = 3
        } else if (duration <= 300) {
            incrementValue = 5
        } else if (duration <= 1200) {
            incrementValue = 10
        } else if (duration <= 3600) {
            incrementValue = 20
        } else {
            incrementValue = 30
        }
        this.setState({ incrementValue, duration });
        // setting time in millis
        if (incrementValue > 2 && this.state.played != 0) {
            this.timer = setTimeout(() => this.handleHitApi(true), incrementValue * 1000)
        }
    }

    ref = player => {
        this.player = player
    }



    toggleMenu = () => {
        this.setState({
            showShare: false,
            showSubscribe: false,
            showMenu: !this.state.showMenu
        })
    }

    toggleShare = () => {
        this.setState({
            showMenu: false,
            showSubscribe: false,
            showShare: !this.state.showShare
        })
    }

    toggleSubscribe = () => {
        this.setState({
            showMenu: false,
            showShare: false,
            showSubscribe: !this.state.showSubscribe
        })
    }

    toggleMoreOptions = () => {
        this.setState({
            showMenu: false,
            showShare: false,
            showSubscribe: false,
            showMoreOptions: !this.state.showMoreOptions
        })
    }

    render() {

        const { url, playing, controls, volume, muted, loop, played, playbackRate } = this.state;
        const themeColor = this.props.themeColor;

        const bgColor = () => this.props.isDark ? " bg-[#252528] " : " bg-white "
        const bgColor2 = () => this.props.isDark ? " bg-[#252528] " : " bg-[#F9FAFB] "
        const textColor = () => this.props.isDark ? " text-gray-200 " : " text-gray-800 "
        const hoverButton = () => this.props.isDark ? " hover:bg-gray-700 " : " hover:bg-gray-200 "
        const textColorLight = () => this.props.isDark ? " text-gray-300 " : " text-gray-600 "
        const playerBg = () => this.props.isDark ? " bg-[#434346] " : " bg-[#F6F6F6] "
        const buttons = () => this.props.isDark ? "#B2B9C4" : "black"
        const sliderBg = () => this.props.isDark ? "#26282D" : "#D1D5DB"
        const divider = () => this.props.isDark ? " bg-[#6C6F74] " : " bg-gray-200 "
        const textColorTheme = () => themeColor ? themeColor : this.props.isDark ? "#736AFF" : "#4F46E5"
        const colorTheme = () => themeColor ? themeColor : this.props.isDark ? "#736AFF" : "#4F46E5"
        const getHeadingFont = () => fonts.find((it) => it.id == this.props.headingFont)['font-family']
        const getBodyFont = () => this.props.bodyFont == 'default' ? 'Manrope' : fonts.find((it) => it.id == this.props.bodyFont)['font-family']
        // Find or create the dynamic style tag for custom theme color for slider
        let styleSheet = document.getElementById("dynamic-styles");
        if (!styleSheet) {
            styleSheet = document.createElement("style");
            styleSheet.id = "dynamic-styles";
            document.head.appendChild(styleSheet);
        }

        // Update the CSS rule for the class you want to override
        styleSheet.innerHTML = `
              .playingTrack-new.playingTrack-new-0{
                background: ${colorTheme()};
                opacity: 70%;
                margin-right: 0.5rem;
                height: 0.5rem;
                border-radius: 0.25rem;
            }

            .playingTrack-new.playingTrack-new-1 {
                background: ${sliderBg()};
            }
                
            .thumb-new {
                background: ${colorTheme()};
            }
        }
            `;

        const playerView = () => {
            return (
                <div className={'flex flex-col rounded-md px-3 relative py-4 sm:py-8 items-center shadow-sm' + playerBg()} >
                    <img src={this.props.isDark ? darkBg : lightBg} className={'h-full w-full rounded-md top-0 bottom-0 absolute  pointer-events-none ' + (this.props.isDark ? 'opacity-90' : 'opacity-100')} />
                    <div className="flex space-x-3 mb-4 z-[5] justify-center items-center">

                        {!this.state.toShowOnlyParticularEpisode && <div onClick={!this.state.toShowOnlyParticularEpisode ? this.playPreviousEpisode : null} class={(this.state.toShowOnlyParticularEpisode ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer')}>
                            <BackwardIcon class="w-6 h-6" color={buttons()} />
                        </div>}
                        <div onClick={this.rewind} class="w-7 h-7 cursor-pointer">
                            <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" stroke-width="3" stroke={buttons()} fill="none"><polyline points="9.57 15.41 12.17 24.05 20.81 21.44" stroke-linecap="round" /><path d="M26.93,41.41V23a.09.09,0,0,0-.16-.07s-2.58,3.69-4.17,4.78" stroke-linecap="round" /><rect x="32.19" y="22.52" width="11.41" height="18.89" rx="5.7" /><path d="M12.14,23.94a21.91,21.91,0,1,1-.91,13.25" stroke-linecap="round" /></svg>
                        </div>
                        {this.state.playing ? <div onClick={this.handlePause} >
                            <PauseIcon className="w-8 w-8 cursor-pointer" color={colorTheme()} />
                        </div> : <div onClick={this.handlePlay} >
                            <PlayIcon className="w-8 w-8 cursor-pointer" color={colorTheme()} />
                        </div>}
                        <div onClick={this.fastForward} class="w-7 h-7 cursor-pointer">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" stroke-width="3" stroke={buttons()} fill="none"><path d="M23.93,41.41V23a.09.09,0,0,0-.16-.07s-2.58,3.69-4.17,4.78" stroke-linecap="round" /><rect x="29.19" y="22.52" width="11.41" height="18.89" rx="5.7" /><polyline points="54.43 15.41 51.83 24.05 43.19 21.44" stroke-linecap="round" /><path d="M51.86,23.94a21.91,21.91,0,1,0,.91,13.25" stroke-linecap="round" /></svg>
                        </div>
                        {!this.state.toShowOnlyParticularEpisode && <div onClick={!this.state.toShowOnlyParticularEpisode ? this.playNextEpisode : null} class={(this.state.toShowOnlyParticularEpisode ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer')}>
                            <ForwardIcon class="w-6 h-6" color={buttons()} />
                        </div>}
                    </div>
                    <div className="flex flex-col w-full" >
                        <ReactSlider
                            className={"w-full h-2 rounded-full"}
                            value={this.state.played}
                            max={1}
                            step={0.000000000000001}
                            trackClassName="playingTrack-new"
                            thumbClassName={"cursor-pointer h-5 w-5 -top-[0.4rem] rounded-full thumb-new"}
                            onChange={this.handleSeekChange}
                            onSliderClick={this.handleSeekMouseUp}
                            onBeforeChange={this.handleSeekMouseDown}
                            onAfterChange={this.handleSeekMouseUp}
                            renderThumb={(props, state) => <div {...props}></div>}
                        />
                        <div className='flex justify-between items-center w-full'>
                            <div className={'flex justify-start items-center w-full px-3 mt-2 text-xs ' + textColor()}>
                                <div className={`mr-2 font-bold text-xs cursor-pointer bg-transparent ${hoverButton()} px-1 pb-[2px] pt-[1px] items-center rounded-full`} onClick={() => this.handleSetPlaybackRate()}>{this.state.playbackRate}x</div>
                                <div className={`bg-transparent p-[2px] ${hoverButton()} cursor-pointer rounded-full`} onClick={this.toggleVolume} >
                                    <svg width="14px" height="14px" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11.1498 3.2876C11.6373 3.77511 12.0241 4.35387 12.2879 4.99083C12.5518 5.62779 12.6875 6.31049 12.6875 6.99993C12.6875 7.68938 12.5518 8.37207 12.2879 9.00904C12.0241 9.646 11.6373 10.2248 11.1498 10.7123M9.60342 4.8346C10.1776 5.40892 10.5002 6.1878 10.5002 6.99993C10.5002 7.81207 10.1776 8.59095 9.60342 9.16527M3.9375 4.81243L6.69084 2.0591C6.75202 1.99799 6.82994 1.95639 6.91476 1.93954C6.99957 1.92269 7.08748 1.93135 7.16737 1.96443C7.24727 1.99752 7.31557 2.05353 7.36365 2.12541C7.41173 2.19728 7.43743 2.28179 7.4375 2.36827V11.6316C7.43743 11.7181 7.41173 11.8026 7.36365 11.8745C7.31557 11.9463 7.24727 12.0024 7.16737 12.0354C7.08748 12.0685 6.99957 12.0772 6.91476 12.0603C6.82994 12.0435 6.75202 12.0019 6.69084 11.9408L3.9375 9.18743H2.63084C2.1175 9.18743 1.63684 8.89168 1.50034 8.3976C1.37522 7.94227 1.31204 7.47215 1.3125 6.99993C1.3125 6.51577 1.37784 6.04735 1.50034 5.60227C1.63684 5.1076 2.1175 4.81243 2.63084 4.81243H3.9375Z" stroke={buttons()} stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                {this.state.showVolume &&
                                    <VolumeBar
                                        colorTheme={colorTheme()}
                                        volume={volume}
                                        sliderBg={sliderBg()}
                                        setVolume={(vol) => this.setState({ volume: vol })}
                                    />
                                }

                            </div>
                            <div className={'flex justify-end items-center w-full px-4 mt-2 text-xs ' + textColor()}>
                                <div ><Duration seconds={this.state.duration * this.state.played} /></div>
                                <div className='mx-1 text-sm'>|</div>
                                <div ><Duration seconds={this.state.duration} /></div>
                            </div>
                        </div>
                    </div>
                </div >
            )
        }

        const moreOptions = () => {
            return (
                <div className={"flex flex-col w-1/3 text-sm z-10 absolute m-1 bottom-16 shadow-md right-1 overflow-y-scroll overflow-x-hidden transition-opacity duration-500 px-4 py-2 rounded-md" + bgColor()}>
                    <div className='cursor-pointer text-base absolute right-2' onClick={() => this.toggleMoreOptions()}>
                        <XMarkIcon color={buttons()} className='w-5 h-5' />
                    </div>
                    <div className={'font-semibold cursor-pointer mt-5 mb-1 '} style={{ color: textColorTheme() }} onClick={() => {
                        this.toggleMoreOptions()
                        this.toggleSubscribe()
                    }}>Subscribe</div>
                    <div className={'font-semibold cursor-pointer my-1' + textColorLight()} onClick={() => {
                        this.toggleMoreOptions()
                        this.toggleShare()
                    }}>Share</div>
                    <div className={'font-semibold cursor-pointer my-1' + textColorLight()} onClick={() => {
                        this.toggleMoreOptions()
                        this.toggleMenu()
                    }}>More</div>
                </div>
            )
        }

        return (
            <div className={'rounded-md relative shadow-lg my-1 mx-0 sm:mx-4 w-full' + bgColor()} style={{ fontFamily: getBodyFont() }}>
                <MoreInfoNew
                    activeEpisode={this.state.activeEpisode}
                    podcast={this.state.podcast}
                    showMenu={this.state.showMenu}
                    isDark={this.props.isDark}
                    onClose={() => {
                        this.toggleMenu()
                    }} />

                <SharePodcast
                    activeEpisode={this.state.activeEpisode}
                    podcast={this.state.podcast}
                    showShare={this.state.showShare}
                    isDark={this.props.isDark}
                    onClose={() => {
                        this.toggleShare()
                    }} />

                <SubscribePodcast
                    platforms={this.props.platforms}
                    podcast={this.state.podcast}
                    rss={this.state.rss}
                    showSubscribe={this.state.showSubscribe}
                    isDark={this.props.isDark}
                    onClose={() => {
                        this.toggleSubscribe()
                    }} />

                {this.state.showMoreOptions && moreOptions()}

                <div className={'items-center justify-center pt-6 pb-2 px-4 sm:pt-6 sm:pb-6 ' + ((this.state.showMenu || this.state.showShare) ? 'pointer-events-none' : '')}>

                    <div className="flex">
                        <div class="flex flex-shrink-0 items-center sm:items-start">
                            <img className='w-16 h-16 sm:w-60 sm:h-60 rounded-md' alt={this.state.activeEpisode.title} src={this.state.activeEpisode.itunes.image} />
                        </div>
                        {/* {this.state.playing ? <div className="pause-new" onClick={this.handlePause}></div> : <div className="play-new" onClick={this.handlePlay}></div>} */}

                        <div className="flex-grow flex flex-col justify-start px-4 py-1 sm:ml-4 md:ml-8 sm:h-60 sm:w-[40rem]">
                            <div className="flex justify-center sm:justify-between flex-col h-full w-full">
                                <div>
                                    <a className='pointer-events-auto hover:underline' target='_blank' href={this.props.podcast.details.link} rel="noopener noreferrer">
                                        <div className={"text-sm font-medium text-black text-ellipsis max-h-[1.5em] overflow-hidden" + textColor()}>{shortenString(this.props.podcast.title)}</div>
                                    </a>
                                    <div className={"font-semibold text-xl pt-1 text-ellipsis max-h-[3.3em] overflow-hidden" + textColor()} style={{ fontFamily: getHeadingFont(), lineHeight: "1.75rem" }}>{shortenString(this.state.activeEpisode.title)}</div>
                                </div>
                                <div className='hidden sm:block'>
                                    {playerView()}
                                </div>
                            </div>
                        </div>

                        <div className='player-wrapper' style={{ display: 'none' }}>
                            <ReactPlayer
                                ref={this.ref}
                                className='react-player'
                                width='0px'
                                height='0px'
                                url={url}
                                playing={playing}
                                controls={controls}
                                loop={loop}
                                playbackRate={playbackRate}
                                volume={volume}
                                muted={muted}
                                onReady={() => { /*console.log('onReady')*/ }}
                                onStart={() => { /*console.log('onStart')*/ }}
                                onPlay={this.handlePlay}
                                onPause={this.handlePause}
                                onBuffer={() => { /*console.log('onBuffer')*/ }}
                                onSeek={e => { /*console.log('onSeek', e)*/ }}
                                onEnded={this.handleEnded}
                                onError={e => { /*console.log('onError', e)*/ }}
                                onProgress={this.handleProgress}
                                onDuration={this.handleDuration}
                            />
                        </div>
                    </div>
                </div>
                <div className='block m-4 sm:hidden'>
                    {playerView()}
                </div>
                <div className={'h-[0.06rem] w-full ' + divider()}>
                </div>
                {!this.state.toShowOnlyParticularEpisode &&
                    <div>
                        <EpisodesNew
                            episodes={this.state.originalOrderedEpisodes}
                            activeEpisode={this.state.activeEpisode}
                            handlePause={this.handlePause}
                            playing={playing}
                            isDark={this.props.isDark}
                            playEpisode={this.playEpisode}
                            height={this.props.height}
                            themeColor={themeColor}
                            headingFont={getHeadingFont()}
                        />
                        <div className={'h-[0.06rem] w-full ' + divider()}>
                        </div>
                    </div>}
                <div className={'flex h-16 rounded-b-md flex-row items-center justify-between px-8 ' + (this.state.toShowOnlyParticularEpisode ? bgColor2() : bgColor())}>
                    <div>
                        <a href={'https://hubhopper.com/'} target="_blank" rel="noopener noreferrer" className={(this.state.isLogo ? ' block ' : ' hidden')}>
                            <img src={this.props.isDark ? darkLogo : lightLogo} style={{ height: '1rem' }} />
                        </a>
                    </div>

                    <div className="flex flex-row space-x-2 text-sm">
                        <div className={'font-semibold cursor-pointer sm:block hidden'} style={{ color: textColorTheme() }} onClick={() => {
                            this.toggleSubscribe()
                        }}>Subscribe</div>
                        <div className={'font-semibold cursor-pointer sm:block hidden' + textColorLight()} onClick={() => {
                            this.toggleShare()
                        }}>Share</div>
                        <div className={'font-semibold cursor-pointer sm:block hidden' + textColorLight()} onClick={() => {
                            this.toggleMenu()
                        }}>More</div>
                    </div>
                    <div className='block sm:hidden cursor-pointer' onClick={() => this.toggleMoreOptions()}>
                        <svg width="20px" height="20px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill={this.props.isDark ? "#ffffff" : "#000000"} class="bi bi-three-dots-vertical">
                            <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                        </svg>
                    </div>
                </div>
            </div>
        );

    };
}

export default TWHHPlayer;
